<nav *transloco="let t" role="navigation" [attr.aria-label]="t('Pagination')">
  <ul>
    <li>
      <a
        app-button
        [attr.aria-label]="t('Previous page')"
        routerLink="./"
        queryParamsHandling="merge"
        [queryParams]="{ page: current === 2 ? null : current - 1 }"
        [style.visibility]="current > 1 ? 'visible' : 'hidden'"
      >
        <svg-icon key="arrow-up"></svg-icon>
      </a>
    </li>
    <li>
      <div class="page-info">
        <span class="visually-hidden">{{ t('Current page:') }}</span>
        {{ current }} {{ t('of') }} {{ total }}
      </div>
    </li>
    <li>
      <a
        app-button
        [style.visibility]="current < total ? 'visible' : 'hidden'"
        routerLink="./"
        queryParamsHandling="merge"
        [queryParams]="{ page: current + 1 }"
      >
        <span class="next-page-label">{{ t('Next page') }}</span>
        <svg-icon key="arrow-up"></svg-icon>
      </a>
    </li>
  </ul>
</nav>
